import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import {
  openReportModal,
  openLoginModal,
} from 'app/dispatcher/modalDispatcher';
import { REPORT_MODAL, TYPES } from 'app/constants/report';
import { setEditOpinionId } from 'app/dispatcher/opinionDispatcher';
import { RootState } from 'app/reducer';

const useOpinionMenu = ({ opinion }) => {
  const { createdByCurrentUser, id } = opinion;

  const router = useRouter();
  const dispatch = useDispatch();

  const isSignedIn = useSelector(
    (state: RootState) => state.auth.session.isSignedIn,
  );

  const reportClick = () => {
    const modalData = {
      id,
      data: REPORT_MODAL[TYPES.OPINION],
    };
    const onClick = () => {
      if (!isSignedIn) {
        sessionStorage.setItem('new-report', JSON.stringify(modalData));
        return dispatch(openLoginModal());
      }
      dispatch(openReportModal(modalData));
    };
    return onClick();
  };

  const editOption = [
    {
      title: 'Edit',
      value: 'edit',
      onClick: () => {
        window.scrollTo(0, 0);
        dispatch(setEditOpinionId(id));
        router.push({
          pathname: '/post-opinion',
        });
      },
    },
  ];

  const reportOption = [
    {
      title: 'Report',
      value: 'report',
      onClick: () => reportClick(),
    },
  ];

  const menuOption = createdByCurrentUser ? editOption : reportOption;

  return menuOption;
};

export default useOpinionMenu;
